import mosaicScreenshot from "../../Assets/马赛克.png";
import mosaicPrototype from "../../Assets/马赛克原型图.png";
import img3 from "../../Assets/3.png";
import img4 from "../../Assets/4.png";
import poster from "../../Assets/海报.png";
import vrPoster from "../../Assets/易拉宝.png";
import smartposPoster from "../../Assets/马拉松.jpg";
import smartposPoster1 from "../../Assets/马拉松1.png";
import ragPoster from "../../Assets/RAG.png";

// 项目数据 - 请根据实际情况填充
const projectData = [
  {
    year: "2026.3",
    title: "特殊教育教师管理自闭症学生艺术治疗课程的综合平台",
    description: "浙大科研实习项目，预计四月初投入杭州中学使用。",
    tech: ["原型设计", "全栈"],
    images: [mosaicScreenshot, mosaicPrototype],
    demo: "https://mosaic.fangyuyang.com",
  },
  {
    year: "2025.12",
    title: "iOS端-AI心理疗愈系统",
    description:
      "系统将检索增强生成（RAG）与支持向量机结合，提升判断专业度与生理压力监测能力，并通过情境工程动态调整治疗建议。压力识别模型准确率约 88%；人类评估显示，相较基线，RAG 架构将治疗同理心评分从 3.1 提升至 4.3。",
    tech: ["产品设计", "RAG", "Agent"],
    images: [img3, img4],
    demo: null,
  },


  {
    year: "2025.10",
    title: "IPad端-智能POS系统",
    description:
      "针对展厅现有 POS 设备静态展示、无交互、无法协同的痛点，打造可听、可感知、可响应的智能“主动终端”。实现全局控制、聚焦控制、交互式控制三大核心功能，并基于服务端与设备的 WebSocket 通信完成指令传输与反馈。获一等奖，获得企业实习机会。",
    tech: ["产品设计", "前端"],
    images: [smartposPoster, smartposPoster1],
    demo: null,
  },
  {
    year: "2025.8",
    title: "web端-企业知识问答系统",
    description:
      "企业实习项目，建立企业知识库，通过爬取企业各部门资料，利用知识检索和 LLM 模型结合，各部门员工可通过问答系统咨询相关问题，准确率约 85%。",
    tech: ["RAG", "LLM"],
    images: [ragPoster],
    demo: null,
  },
  {
    year: "2025.7",
    title: "VR-音乐冥想游戏",
    description:
      "专为 Apple Vision Pro 量身定制的空间音乐创作应用，融合空间交互、音乐创作、冥想疗愈与社区分享，打造沉浸式数字空间体验。",
    tech: ["产品", "UI", "前端"],
    images: [vrPoster],
    demo: null,
  },
  {
    year: "2025.4",
    title: "Web端-多模态大模型驱动的道路状况综合识别系统",
    description:
      "系统采用多模态大模型与实时目标检测协同工作：中心服务器使用 Qwen2.5-VL 负责复杂场景语义理解，云端使用 YOLOv11 专注实时目标检测，实现道路状况的综合识别。完成产品化开发，并进行 AI 微调与蒸馏优化。项目获服务外包创新创业国家二等奖，UXDA 国家三等奖。",
    tech: ["多模态大模型", "产品设计", "AI 微调与蒸馏"],
    images: [poster],
    demo: null,
  },
];

export default projectData;
